import { AttributeListForComponentTypes } from '@source-components-react/types';

/**
 * Mapping of component IDs to their supported modifiable attributes.
 *
 * Each component type can have a specific list of attributes that users are allowed to modify
 * in the editor. This mapping defines which attributes are available for each component type.
 *
 * Note: This defines which attributes each component supports, while component-name-to-modify-attribute.ts
 * defines which editor component should be used to modify each attribute type.
 * todo: this is a little confusing and might require a deeper look into how RuleCMS uses this.
 */
/**
 * Empty on purpose. Every component this library ships declares its editable
 * attributes through its own `attribute-edit-mode-configs.ts`, which is the
 * path the composer's Modify drawer reads. Listing an attribute here as well
 * shows it twice — once through the legacy shared-attribute editor, which has
 * no entry for modern `-3-resolutions` names and renders an empty section.
 */
export const attributeListForComponentTypes: AttributeListForComponentTypes = {};
